import { render } from "./form-part-b-confirmation.html?vue&type=template&id=4abb5328&scoped=true&ts=true&external"
import script from "./form-part-b-confirmation.ts?vue&type=script&lang=ts&external"
export * from "./form-part-b-confirmation.ts?vue&type=script&lang=ts&external"

import "./form-part-b-confirmation.scss?vue&type=style&index=0&id=4abb5328&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abb5328"]])

export default __exports__